export default [
  {
    path: '/:locale([en/]*)?/fonts',
    name: 'Fonts',
    component: () => import('@/views/fonts/Index'),
    meta: {
      sitemap: {
        loc: '/fonts'
      }
    }
  },
  {
    path: '/:locale([en/]*)?/fonts/license',
    name: 'FontsLicense',
    component: () => import('@/views/fonts/License'),
    meta: {
      language: false,
      parent: 'Fonts',
      sitemap: {
        loc: '/fonts/license'
      }
    }
  },
]
